<template>
  <div class="map-modal" v-if="showMap">
    <div class="modal-content">
      <p class="close" @click="showMap = false">Close</p>
      <div id="map"></div>
      <div class="modal-footer">
        <div class="location">
          <p class="office">{{ office_name }}</p>
          <p class="address" v-html="address"></p>
          <p class="phone">{{ phone }}</p>
        </div>
        <div class="button giant">
          <span> Get Directions </span>
          <span class="flex">
            <a :href="directionsLink" target="_blank">
              click here <img src="/images/icons/right-red.svg" alt="" />
            </a>
          </span>
        </div>
      </div>
    </div>
    <div class="overlay" @click="showMap = false"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showMap: false,
      office_name:'',
      address: '',
      phone: '',
      direction: '',
      lat:'',
      lng:''
    };
  },
  computed: {
    directionsLink(){
      let url = "http://maps.google.com/maps?daddr=";
      let dest = this.direction.replace(/(<([^>]+)>)/gi, "");
      return url + dest;
    }
  },
  methods: {
    initGmap(lat, lng) {
      var map = document.querySelector("#map");
      var curpoint = new google.maps.LatLng(lat, lng);
      var gmapdata = new google.maps.Map(map, {
        center: curpoint,
        zoom: 16,
        mapTypeId: "roadmap",
      });

      var icon = {
        url: "/images/marker.png",
        size: new google.maps.Size(43, 57),
        scaledSize: new google.maps.Size(43, 57),
      };

      var gmapmarker = new google.maps.Marker({
        map: gmapdata,
        icon: icon,
        position: curpoint,
      });
    },
  },
  mounted() {

    const button = document.querySelectorAll(".item .button");
    button.forEach((btn) => {
      btn.addEventListener("click", () => {
        this.showMap = true;
        this.lng = btn.getAttribute('data-lng');
        this.lat = btn.getAttribute('data-lat');
        this.phone = btn.getAttribute('data-phone');
        this.direction = btn.getAttribute('data-direction');
        this.office_name = btn.getAttribute('data-office-name');
        this.address = btn.getAttribute('data-address');

        setTimeout(() => {
          this.initGmap(this.lat, this.lng);
        }, 500);
      });
    });
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/MapModal.vue